import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecruitingService } from 'src/app/api/recruiting.service';
import { LocationRecruiting } from 'src/app/api/types/recruiting';
import { UiModule } from 'src/app/ui/ui.module';

interface LocationRecruitingItem {
  data: LocationRecruiting;
  originalPercentage: number;
  actualPercentage: number;
  originalDisplayPercentage: number;
  actualDisplayPercentage: number;
}

@Component({
  selector: 'app-location-recruiting',
  templateUrl: './location-recruiting.component.html',
  styleUrls: ['./location-recruiting.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    UiModule
  ]
})
export class LocationRecruitingComponent implements OnInit {
  locationData: LocationRecruitingItem[] = [];
  loading: boolean = true;
  error: string | null = null;

  constructor(private recruitingService: RecruitingService) { }

  ngOnInit(): void {
    this.loadLocationData();
  }

  private loadLocationData() {
    this.loading = true;
    this.error = null;

    this.recruitingService.getLocationRecruiting().subscribe({
      next: (data) => {
        this.locationData = data.map(item => ({
          data: item,
          originalPercentage: this.calculatePercentage(item.currentOriginal, item.original),
          actualPercentage: this.calculatePercentage(item.currentActual, item.actual),
          originalDisplayPercentage: this.getDisplayPercentage(item.currentOriginal, item.original),
          actualDisplayPercentage: this.getDisplayPercentage(item.currentActual, item.actual)
        }));
        
        this.loading = false;
      },
      error: (err) => {
        this.error = 'Failed to load location data: ' + (err.message || 'Unknown error');
        this.loading = false;
        console.error('Error loading location data:', err);
      }
    });
  }

  private calculatePercentage(current: number, goal: number | null): number {
    if (!goal || goal === 0) return 100;
    return Math.round((current / goal) * 100);
  }

  private getDisplayPercentage(current: number, goal: number | null): number {
    let percentage = this.calculatePercentage(current, goal);
    if (percentage > 100) percentage = 100;
    return percentage;
  }

  getKnobColor(percentage: number): string {
    return percentage < 100 ? 'rgba(28, 132, 198, 0.7)' : '#1ab394';
  }
} 